<script setup lang="ts">
const lang = useLocale()
const refElem = useTemplateRef('refElem')

const timer = useTimeout()
watch(
  () => ({ l: lang.value, elem: refElem.value }),
  ({ l, elem }) => {
    timer.set(() => {
      if (!elem) return
      const script = document.createElement('script')
      script.id = 'CookieDeclaration'
      script.type = 'text/javascript'
      script.async = true
      script.src = 'https://consent.cookiebot.com/c914d357-bb78-47ee-9c09-d90123eb5c18/cd.js'
      script.setAttribute('data-culture', l)
      elem.appendChild(script)
    }, 100)
  },
  { immediate: true }
)
</script>

<template>
  <div class="_pt4 _mt4 _b5 _bw100">
    <div :key="lang" ref="refElem" />
  </div>
</template>
